import { DatePipe } from '@angular/common';
import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer } from '@angular/platform-browser';
import { provideIcons } from '@ng-icons/core';
import { lucideEllipsisVertical, lucidePen, lucidePlus, lucideTrash } from '@ng-icons/lucide';
import { ConfirmDialogComponent } from '@shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { filter } from 'rxjs';
import { FormMessageInformationComponent } from './form-message-information/form-message-information.component';
import { Message } from './model/message.model';
import { MessageInformationStore } from './store/message-information.store';

@Component({
  selector: 'app-messages-information',
  imports: [HlmCardImports, HlmButtonImports, HlmTableImports, HlmIconImports, HlmDropdownMenuImports, DatePipe],
  providers: [provideIcons({ lucidePlus, lucideEllipsisVertical, lucideTrash, lucidePen })],
  templateUrl: './messages-information.component.html',
})
export class MessagesInformationComponent implements OnInit {
  readonly #sidepanelService = inject(SidepanelService);
  readonly #messageStore = inject(MessageInformationStore);
  readonly #sanitizer = inject(DomSanitizer);
  readonly #dialog = inject(HlmDialogService);
  readonly #destroyRef = inject(DestroyRef);

  readonly messages = computed(() =>
    this.#messageStore.entities().sort((a, b) => (a.dateDebut < b.dateDebut ? 1 : -1)),
  );

  contenuSanitise(contenu: string) {
    return this.#sanitizer.bypassSecurityTrustHtml(contenu);
  }

  ngOnInit(): void {
    this.#messageStore.charger(false);
  }

  ajouterMessage() {
    this.#sidepanelService.setComponentToDisplay("Ajouter un message d'information", FormMessageInformationComponent);
    this.#sidepanelService.open();
  }

  modifierMessage(message: Message) {
    this.#sidepanelService.setComponentToDisplay(
      'Modifier le Message',
      FormMessageInformationComponent,
      `Vous pouvez modifier le Message sélectionné.`,
      { message },
    );
    this.#sidepanelService.open();
  }

  supprimerMessage(message: Message) {
    const dialogRef = this.#dialog.open(ConfirmDialogComponent, {
      context: {
        titre: `Êtes-vous sûr de vouloir supprimer le message ${message.titre} ?`,
        contenu: `Vous êtes sur le point de supprimer <b>${message.titre}</b>. Cette action est définitive et ne peut pas être annulée.`,
      },
    });
    dialogRef.closed$
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        filter((result: boolean) => result),
      )
      .subscribe(async () => this.#messageStore.supprimer(message.id));
  }
}
